import React from "react";
import SignInForm from "./LeftPannel";
import InfoPanel from "../components/RightPannel";
const PasswordChanged = () => {
  return (
    <InfoPanel parent="newpassword">
      <SignInForm />
    </InfoPanel>
  );
};

export default PasswordChanged;
